import { combineReducers } from 'redux';

import article from './article/articleReducer';

export default combineReducers({
	article,
});
